import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Button } from './components/ui/button';
import AppHeader from './components/AppHeader';
import Login from './pages/Login';
import AdminUsers from './pages/AdminUsers';
import AdminRoles from './pages/AdminRoles';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AcceptInvite from './pages/AcceptInvite';
import TradingConsole from './pages/TradingConsole';
import Profile from './pages/Profile';
import Skill from './pages/Skill';
import Backtests from './pages/Backtests';
import Scan from './pages/Scan';

function Home() {
  return (
    <div className="app-shell">
      <AppHeader />
      <main className="flex flex-1 flex-col items-center justify-center p-6">
        <img src="/favicon.ico" className="w-24 h-24 mb-6" alt="trading-console-app logo" />
        <h1 className="text-4xl font-bold mb-4">trading-console-app</h1>
        <p className="text-muted-foreground mb-6">Full-stack Express TypeScript + React + shadcn/ui</p>
        <Button asChild>
          <a href="https://reactjs.org" target="_blank" rel="noopener noreferrer">Learn React</a>
        </Button>
      </main>
    </div>
  );
}

function AuthOrLogin() {
  const [isAuthed, setIsAuthed] = React.useState<boolean | null>(null);
  React.useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/auth/me');
        setIsAuthed(res.ok);
      } catch {
        setIsAuthed(false);
      }
    })();
  }, []);
  if (isAuthed === null) return <div className="p-4 text-center text-sm text-muted-foreground">Loading...</div>;
  return isAuthed ? <Navigate to="/" replace /> : <Login />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute><TradingConsole /></ProtectedRoute>} />
      <Route path="/login" element={<AuthOrLogin />} />
      <Route path="/skill" element={<Skill />} />
      <Route path="/backtests" element={<ProtectedRoute><Backtests /></ProtectedRoute>} />
      <Route path="/backtests/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/home" element={<Home />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/invite" element={<AcceptInvite />} />
      <Route path="/admin/users" element={<ProtectedRoute permissions={['users.read']}><AdminUsers /></ProtectedRoute>} />
      <Route path="/admin/roles" element={<ProtectedRoute permissions={['roles.read']}><AdminRoles /></ProtectedRoute>} />
    </Routes>
  );
}
